const SAVINGS = [
  {
    scale: ['SAVE', 'WEEKS'],
    title: 'Understanding the gap',
    body: 'Requirements structured into parameters the office can act on.',
  },
  {
    scale: ['SAVE', 'MONTHS'],
    title: 'Finding and vetting solutions',
    body: 'A comparable, assessed set of vendors instead of open-source digging.',
  },
  {
    scale: ['SAVE', 'YEARS'],
    title: 'Choosing the pathway',
    body: 'Faster routes stop being specialist knowledge.',
  },
  {
    scale: ['ONGOING'],
    title: 'Speed that compounds',
    body: 'What one office learns, every office can use.',
  },
]

export default function Results() {
  return (
    <section id="results" className="lp-sec lp-sec--lift">
      <div className="lp-wrap lp-two">
        <div style={{ minWidth: 0 }}>
          <div className="lp-eyebrow">THE DIFFERENCE IT MAKES</div>
          <h2 className="lp-h2" style={{ marginBottom: 20 }}>
            Knock years off the clock between the gap and the field.
          </h2>
          <p className="lp-lede lp-results__lede">
            Overmatch helps you ensure the readiest vendor reaches the warfighter
            by the most expedient route. Program staff get to spend their time on
            the judgment only they can supply. And leadership can see change
            happening at scale.
          </p>
        </div>

        <div className="lp-save">
          {SAVINGS.map((s) => (
            <div key={s.title} className="lp-save__row">
              <div className="lp-save__scale">
                {s.scale.map((line, i) => (
                  <span key={line}>
                    {i > 0 && <br />}
                    {line}
                  </span>
                ))}
              </div>
              <div>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
